<template>
  <div>
    <b-card>
      <Grid
        name="DsrCodesGrid"
        v-bind:url="url"
        v-bind:columns="columns"
        :pageable="false"
        :filterable="true"
        :sortable="true"
      ></Grid>
    </b-card>
  </div>
</template>

<script>
import Grid from '@/components/LocalGrid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'DsrCodesGrid',
  components: {
    Grid
  },
  data() {
    return {
      schemaModelFields: {
        'created_at': {
          type: 'date'
        }
      },
      url: 'dsr/lst/codes',
      columns: [{
        field: 'dealer.data.name',
        title: 'Distribuidor',
        width: '250px'
      }, {
        field: 'code',
        title: 'Código vendedor',
        width: '150px'
      },{
        field: 'dsr_id',
        title: 'DSR ID',
        width: '150px',
      }, {
        field: 'date_start',
        title: 'Data inicial',
        format: '{0:dd/MM/yyyy}',
        type: 'date',
        width: '220px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDatePicker({
              format: 'dd/MM/yyyy'
            })
          }
        }
      }, {
        field: 'date_end',
        title: 'Data final',
        format: '{0:dd/MM/yyyy}',
        type: 'date',
        width: '220px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDatePicker({
              format: 'dd/MM/yyyy'
            })
          }
        }
      }]
    }
  }
}
</script>
